import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  PersonState,
  PersonSupplementaryInsuranceState,
  SupplementaryInsuranceTypes,
} from '../../../../../core/states/offer/offer.state';
import { getOrderedSupplementaryInsurances } from '../../../../../core/models/supplementary-insurance-order';
import { PersonService } from '../../../../../core/services/person.service';
import { Observable } from 'rxjs';

export interface BasketSupplementaryInsurance {
  productStateKey: SupplementaryInsuranceTypes;
  productTranslationKey: string;
  price?: number;
}

@Component({
  standalone: false,
  selector: 'ssc-basket-person-detail',
  templateUrl: './basket-person-detail.component.html',
  styleUrls: ['./basket-person-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasketPersonDetailComponent implements OnChanges {
  @Input() public person: PersonState;
  @Input() public isOpen: boolean;
  @Input() public isSinglePerson: boolean;
  @Input() public isActivePerson: boolean;
  @Input() public isTupCustomer: boolean | null;
  @Output() public personToggled = new EventEmitter<void>();
  @Output() public toPersonClick = new EventEmitter<void>();
  @Output() public removeSupplementaryInsuranceClick = new EventEmitter<keyof PersonSupplementaryInsuranceState>();
  @Output() public removeBasicInsuranceClick = new EventEmitter<void>();

  public personName$: Observable<string>;
  public supplementaryInsurancesOfPerson: BasketSupplementaryInsurance[];

  constructor(private personService: PersonService) {}

  public onPersonToggled(): void {
    this.personToggled.emit();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.personName$ = this.personService.getFirstNameOrFallback$(this.person.details.firstName, this.person.personId);
    this.supplementaryInsurancesOfPerson = this.getSupplementaryInsurances();
  }

  private static camelCaseToScreamingSnakeCase(text: string): string {
    return text.replace(/[A-Z]/g, (letter) => `_${letter}`).toUpperCase();
  }

  private getSupplementaryInsurances(): BasketSupplementaryInsurance[] {
    const supplementaryInsurance = this.person.supplementaryInsurances;
    return getOrderedSupplementaryInsurances(supplementaryInsurance).map((insurance) => ({
      productStateKey: insurance.key,
      productTranslationKey: BasketPersonDetailComponent.camelCaseToScreamingSnakeCase(insurance.key),
      price: insurance.insuranceState.price,
    }));
  }
}
